var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 question-content",domProps:{"innerHTML":_vm._s(_vm.question.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }